import { render, staticRenderFns } from "./displaySetting.vue?vue&type=template&id=63c2af91&scoped=true"
import script from "./displaySetting.vue?vue&type=script&lang=js"
export * from "./displaySetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63c2af91",
  null
  
)

export default component.exports